import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [combineActions(rawActions.getTrackingsRequest, rawActions.getTrackingsFailed)](state, action) {
      return false
    },
    [rawActions.getTrackingsSuccess](state, action) {
      return true
    },
    [rawActions.resetTracking]() {
      return false
    },
  },
  false
)
